export default __webpack_public_path__ + "fa6773a8410587a17621db4c1650c429.svg";